import React from 'react';
import AddOnTag from './AddOnTag';
import { ADDON_MAPPER } from '../config/common';

const AddOnTags = ({ addOns, short = false }) => {
	if (addOns && addOns.length === 0) {
		return short ? '-' : 'Inga';
	}
	const types = addOns.map((addOn) => addOn.type);

	return (
		<span style={{ display: 'flex', flexWrap: short ? 'nowrap' : 'wrap', rowGap: 8 }}>
			<AddOnTag
				name={short ? 'HR' : 'HR Handbok'}
				color='blue'
				enabled={types.includes(ADDON_MAPPER.KEYS.RM_HANDBOOK)}
			/>
			<AddOnTag
				name={short ? 'LK' : 'Lagkommentarer'}
				color='green'
				enabled={types.includes(ADDON_MAPPER.KEYS.LEGAL_COMMENTS)}
			/>
			<AddOnTag
				name={short ? 'E-lit' : 'E-litteratur'}
				color='orange'
				enabled={types.includes(ADDON_MAPPER.KEYS.E_LITERATURE)}
			/>
			<AddOnTag
				name={short ? 'LB' : 'Lagbevakning (Extern)'}
				color='red'
				enabled={types.includes(ADDON_MAPPER.KEYS.COMPLIANCE)}
			/>
			<AddOnTag
				name={short ? 'R+' : 'Rättsfall Plus'}
				color='purple'
				enabled={types.includes(ADDON_MAPPER.KEYS.LEGAL_CASE_PLUS)}
			/>
			<AddOnTag
				name={short ? 'Ai' : 'Ai Funktioner'}
				color='cyan'
				enabled={types.includes(ADDON_MAPPER.KEYS.AI_FUNCTIONS)}
			/>
			<AddOnTag
				name={short ? 'Socrates' : 'Socrates'}
				color='pink'
				enabled={types.includes(ADDON_MAPPER.KEYS.SOCRATES)}
			/>
		</span>
	);
};

export default AddOnTags;



// WEBPACK FOOTER //
// ./src/components/AddOnTags.jsx